import AccessTime from '@mui/icons-material/AccessTime';
import Logout from '@mui/icons-material/Logout';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { StyledButton } from '@src/components/core/styled-button';

export default function WarningState({
  timeUntilSessionExpires,
  submitting,
  onSignOut,
  onStay,
}: {
  timeUntilSessionExpires: number;
  submitting: boolean;
  onSignOut: () => void;
  onStay: () => void;
}) {
  return (
    <>
      <Box maxWidth='30rem'>
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          gap={2}
          p={3}
          sx={(theme) => ({
            background: theme.customGradients.primary,
            color: theme.palette.common.white,
          })}
        >
          <AccessTime fontSize='large' />
          <Typography variant='h4' textAlign='center'>
            Still working?
          </Typography>
        </Box>
        <Divider flexItem />
        <Box p={4}>
          <Typography variant='body1' mb={4} textAlign='center'>
            For your security, you will be automatically signed out in
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 5 }} display='flex' justifyContent='end'>
              <CircularProgress
                value={(timeUntilSessionExpires / 60) * 100}
                variant='determinate'
                thickness={22}
                enableTrackSlot
                color='secondary'
              />
            </Grid>
            <Grid size={{ xs: 'auto' }} display='flex' alignItems='center'>
              <Typography variant='h5'>
                {timeUntilSessionExpires} seconds
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Divider flexItem />
      <Box
        width='100%'
        display='flex'
        gap={2}
        p={2}
        sx={(theme) => ({
          background: theme.customGradients.primary,
          color: theme.palette.common.white,
        })}
      >
        <StyledButton
          size='large'
          color='inherit'
          fullWidth
          normalCase
          variant='outlined'
          onClick={onSignOut}
          endIcon={<Logout />}
          disabled={submitting}
        >
          Sign Out
        </StyledButton>
        <StyledButton
          size='large'
          color='primary'
          fullWidth
          normalCase
          variant='contained'
          onClick={onStay}
          disabled={submitting}
        >
          Stay Signed In
        </StyledButton>
      </Box>
    </>
  );
}
